import { Select, MenuItem } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

const SettingsAccountingMethod = (props) => {
    const {
        facilityUid,
        accountingMethod,
        fieldConfiguration,
        initialized,
        onChange,
    } = props;

    const [loading, setLoading] = useState(true);
    const [facilityAccountingMethod, setFacilityAccountingMethod] = useState(accountingMethod);
    const [displayValue, setDisplayValue] = useState('');

    const { accounting_method: accountingMethodConfig } = fieldConfiguration.facilitySettings;

    useEffect(() => {
        if (!initialized) return;

        setFacilityAccountingMethod(accountingMethod);
        setDisplayValue(getDisplayValue(accountingMethod, accountingMethodConfig))
        setLoading(false);
    }, [accountingMethod, accountingMethodConfig, facilityUid, initialized]);

    const handleChange = async (event) => {
        onChange(event.target.value);
        setFacilityAccountingMethod(event.target.value);
        setDisplayValue(getDisplayValue(event.target.value, accountingMethodConfig))
    };

    function getDisplayValue(accountingMethod, config) {
        for (const option of config.options) {
            if (option.value === accountingMethod) {
                return option.label
            }
        }
    }

    if (loading) {
        return <div><span>Loading Accounting Method...</span></div>;
    }

    if (props.editMode) {
        const { accounting_method: accountingMethodConfig } = fieldConfiguration.facilitySettings;
        return (
            <>
                <div className='parkchirp-payment-application-row'>
                    <div className='parkchirp-payment-application-row-label'>Accounting Method</div>
                    <Select
                        className='parkchirp-payment-application-row-field'
                        labelId="accounting-method"
                        id="accounting-method"
                        value={facilityAccountingMethod}
                        onChange={handleChange}
                    >
                        {accountingMethodConfig.options.map(({ value, label }) => (
                            <MenuItem value={value}>{label}</MenuItem>
                        ))}
                    </Select>
                </div>
            </>
        )
    }

    return (
        <>
            <div className='parkchirp-payment-application-row'>
                <div className='parkchirp-payment-application-row-label'>
                    Accounting Method:
                </div>
                <div className='parkchirp-payment-application-row-value'>
                    {displayValue}
                </div>
            </div>
        </>
    );
}

export default SettingsAccountingMethod;